export const MAIN_DRAW_TARGET_ID = 'main-draw' as const;
